import { useMutation } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast, showSuccessToast } from "#app/notifications";
import { createResetFileHashes } from "#modules/admin/infra/resetFileHashes.api";

export const useResetFileHashes = (params?: {
  options?: {
    onSuccess?: () => void;
    onError?: (err: Error) => void;
    onMutate?: () => void;
  };
}) => {
  const { mutate, ...rest } = useMutation({
    mutationFn: createResetFileHashes,
    onMutate: () => {
      params?.options?.onMutate?.();
    },
    onSuccess: () => {
      params?.options?.onSuccess?.();
      showSuccessToast({ title: "Cache supprimé" });
    },
    onError: (err: Error) => {
      showErrorToast({ title: err.message });
      errorHandler(err);

      params?.options?.onError?.(err);
    },
  });

  return { resetFileHashes: mutate, ...rest };
};
